<template>
    <div class="default-border-root">
        <div class="border-top">
            <div class="border-tl"></div>
            <div class="border-tc">
                <DeText v-if="showTitle" :text="title" :textStyle="titleFont"></DeText>
            </div>
            <div class="border-tr"></div>
        </div>
        <div class="border-center">
            <div class="border-cl"></div>
            <div class="border-cc">
                <slot></slot>
            </div>
            <div class="border-cr"></div>
        </div>
        <div class="border-bottom">
            <div class="border-bl"></div>
            <div class="border-bc"></div>
            <div class="border-br"></div>
        </div>
    </div>
</template>
<style lang="less" scoped>
    .default-border-root{
        display: flex;
        flex-direction: column;
        height: 100%;
        .border-center{
            flex: 1;
            display: flex;
            .border-cc{
                position: relative;
                flex: 1;
            }
        }
    }
</style>
<script>
import DeText from '../../../components/text/index'
export default {
    props:["title", "titleFont", "showTitle"],
    components:{
        DeText
    }
}
</script>